import styles from './styles.scss';
import React from 'react';



export default (props) => {

  const { text } = props;

  return (
    <div className={styles.emptyBox}>
      <label className={styles.emptyText}>{text}</label>
    </div>
  )
}
